export const PagerType = {
  ARROW: 'arrow',
  ELLIPSIS: 'ellipsis',
  NUMBER: 'number',
}
